define(
  'viewmodels/app/analytics/__printCharts',['knockout', './__settings', 'atn/atn', './__print'],
  function (ko, settings, atn, printAnalytics) {
      'use strict';
      var printChartVM = getPrintChartVM(getPrintInfo);

      return printChartVM;

      /**
       * factory to generate VM for printing charts (eg: engagement)
       * @param  {Function} getPrintInfo Function to get current print info
       * @return {Object}                ViewModel for print charts as PDF
       */
      function getPrintChartVM(getPrintInfo) {

          return {
              printCharts: printCharts,
              getPrintInfo: getPrintInfo,
              title: atn.config.messages.graphs.actions.downloadPdf
          };
          /**
           * to print analytics chart
           * @return {undefined}
           */
          function printCharts(orderedChartList) {
              printAnalytics.print(getPrintInfo(orderedChartList));
          }
      }

      /**
       * to get the print-info for demographics
       * @return {Object} info required for printing demographics
       */
      function getPrintInfo(orderedChartList) {
          var GRAPHS = settings.GRAPHS,
            CHART_METADATA = GRAPHS.CHART_METADATA,
            DURATION = GRAPHS.GLOBAL.FILTERS.DURATION,
            DURATION_LIST = GRAPHS.GLOBAL.DURATION_DAYS,
            INTERVAL = GRAPHS.GLOBAL.FILTERS.INTERVAL,
            globalMessages = atn.config.messages.graphs,
            printInfo = {
                name: 'Operations Insights Report',
                charts: _.map(
                  orderedChartList,
                  function (chartView) {
                      return {
                          name: chartView.labelsAndStrings.TITLE,
                          chartOptions: chartView.chartOptions,
                          filters: chartView.filters,
                          totalValueGraphCount: chartView.totalValueGraphCount,
                          dateGeneratedOn: chartView.dateGeneratedOn,
                          showDataAvailability: chartView.showDataAvailability,
                          noDataMessage: globalMessages.zeroData,
                          dateInterval: chartView.dateInterval,
                          vm: chartView
                      };
                  }
                )
            };
          return printInfo;
      }
  });

